module.exports = __webpack_public_path__ + "static/media/ms.18f0fd05.png";